module.exports = __webpack_public_path__ + "9facc6eb8dc55af882461b2455d7a47f.svg";